import React from 'react'
import { ReactComponent as BuildAudienceStep1 } from '../../images/icons/build_audience_step1.svg'
import { ReactComponent as BuildAudienceStep2 } from '../../images/icons/build_audience_step2.svg'
import { ReactComponent as BuildAudienceStep3 } from '../../images/icons/build_audience_step3.svg'

const BuildAudienceGuide = () => {
  return (
    <div className={'grid grid-cols-3 gap-3'}>
      <div
        className={
          'flex flex-col gap-3 border-2 rounded-xl text-center p-3 items-center relative min-h-[325px]'
        }>
        <BuildAudienceStep1 />
        <span className={'font-bold text-sm'}>Import your customers</span>
        <span className={'text-sm'}>
          Import your customers from your DMS or manually. This is the first step of
          reaching your perfect customer
        </span>
        <div
          className={
            'border-2 bg-gainsboro-gray rounded-full w-fit px-2 py-1 text-xs font-bold bottom-3 absolute'
          }>
          1
        </div>
      </div>
      <div
        className={
          'flex flex-col gap-3 border-2 rounded-xl text-center p-3 items-center relative min-h-[325px]'
        }>
        <BuildAudienceStep2 />
        <span className={'font-bold text-sm'}>Creating an audience</span>
        <span className={'text-sm'}>
          Filter your imported customers with filters of your choice to ensure you are
          targeting exactly who you want
        </span>
        <div
          className={
            'border-2 bg-gainsboro-gray rounded-full w-fit px-2 py-1 text-xs font-bold bottom-3 absolute'
          }>
          2
        </div>
      </div>
      <div
        className={
          'flex flex-col gap-3 border-2 rounded-xl text-center p-3 items-center relative min-h-[325px]'
        }>
        <BuildAudienceStep3 />
        <span className={'font-bold text-sm'}>Market to the audience</span>
        <span className={'text-sm'}>
          With the filtered audience, you can now deploy this to one of our various
          professional marketing platforms, including Google, Facebook, and many more!
        </span>
        <div
          className={
            'border-2 bg-gainsboro-gray rounded-full w-fit px-2 py-1 text-xs font-bold absolute bottom-3'
          }>
          3
        </div>
      </div>
    </div>
  )
}

export { BuildAudienceGuide }
